
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/shipping-return-policy",
      function () {
        return require("private-next-pages/article/shipping-return-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/shipping-return-policy"])
      });
    }
  